import src from "IMAGE";
export default { src, width: 569, height: 404, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
